var _g, _rect, _g2, _rect2, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveyLongName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5406_10774)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.1836,
    y: 11.4292,
    width: 64.68,
    height: 58.8461,
    rx: 1.96,
    fill: "#E4E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.796 41.7614C55.5734 40.2243 58.1614 35.1731 56.5764 30.4791C54.9914 25.7851 49.8336 23.2259 45.0562 24.763C40.2788 26.3001 37.6909 31.3514 39.2759 36.0453C40.8609 40.7393 46.0186 43.2985 50.796 41.7614Z",
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2613 27.7493C42.2366 25.8479 43.8511 24.3516 45.9282 23.6603C50.4202 22.1652 55.3847 24.9935 57.0086 29.9718C57.5658 31.6799 57.6577 33.4207 57.3575 35.0303C50.3327 34.0323 48.8497 26.4772 48.8497 26.4772C45.9201 28.7859 43.0417 28.3933 41.2613 27.7493Z",
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9715 74.1298L60.0204 70.6C60.0204 70.6 45.9248 81.6744 37.5982 69.8413C29.6448 76.6246 20.3254 82.7546 10.7148 87.5978C6.69772 89.6246 1.86778 88.9582 -1.43729 85.9207C-1.44076 85.9247 -1.44077 85.9247 -1.44077 85.9247C-4.23664 83.3556 -4.95874 79.2051 -3.20115 75.8101C-1.42474 72.4251 1.94206 67.689 8.28126 61.4164C8.28126 61.4164 14.5428 54.8604 18.2094 51.0214C25.0198 43.8926 45.5281 46.2857 54.0224 46.7176C59.8019 47.0178 65.1375 49.8891 68.586 54.5551C73.6867 61.4561 81.5558 72.1872 87.6951 80.9277L76.4947 88.9006C71.9467 84.1098 67.3759 79.378 63.0171 74.1226L62.9715 74.1298Z",
    fill: "#8372FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.9186,
    y: 12.1642,
    width: 63.21,
    height: 57.376,
    rx: 1.225,
    stroke: "#1B1B1B",
    strokeWidth: 1.47
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5406_10774)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.4,
    height: 42,
    rx: 1.96,
    transform: "matrix(-1 0 0 1 105.6 44.3999)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 68.3995C76.6922 68.3995 73.2 65.176 73.2 61.1995C73.2 57.2231 76.6922 53.9995 81 53.9995C85.3079 53.9995 88.8 57.2231 88.8 61.1995C88.8 65.176 85.3079 68.3995 81 68.3995Z",
    stroke: "#1B1B1B",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7857 53.9995C80.8391 57.6712 83.7268 64.9948 85.6001 67.1995C87.5356 65.8808 88.8 63.7103 88.8 61.2583C88.8 57.422 85.705 54.275 81.7857 53.9995Z",
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4402 65.6396C86.6242 65.7487 87.0876 65.7323 87.2983 65.775C87.9896 65.9149 88.6769 66.0772 89.3612 66.248C91.4776 66.7761 93.564 67.4117 95.5384 68.3557C96.9749 69.0426 98.4789 69.912 99.1585 71.4341C100.147 73.6467 98.3906 75.6325 96.1079 75.4247C93.9064 75.2243 92.1786 73.6136 90.7117 72.0989C88.9955 70.3266 87.0358 68.4164 85.7199 66.3014",
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5818 73.5645C90.5053 76.3796 95.9062 83.2415 98.5195 87.2002L55.3995 87.2003C58.884 83.5347 60.6262 80.1611 68.0306 74.4438C71.7733 71.554 77.1773 70.0457 84.5818 73.5645Z",
    fill: "#FFBB00"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.735,
    y: 0.735,
    width: 48.93,
    height: 40.53,
    rx: 1.225,
    transform: "matrix(-1 0 0 1 104.13 44.3999)",
    stroke: "#1B1B1B",
    strokeWidth: 1.47
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.2598 18.3796C89.1907 18.3796 98.4179 21.1236 103.88 32.0996",
    stroke: "#FFBB00",
    strokeWidth: 2.94
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.84 35.0396L105.587 23.7264L95.9158 29.6019L105.84 35.0396ZM85.2598 19.3596C88.3241 19.3596 94.9386 21.2229 100.498 28.1181L102.024 26.8878C96.1039 19.5455 88.9352 17.3996 85.2598 17.3996V19.3596Z",
    fill: "#FFBB00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5406_10774"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.1836,
    y: 11.4292,
    width: 64.68,
    height: 58.8461,
    rx: 1.96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5406_10774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.4,
    height: 42,
    rx: 1.96,
    transform: "matrix(-1 0 0 1 105.6 44.3999)",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyLongName);
export default __webpack_public_path__ + "static/media/survey-long-name.b97a5362.svg";
export { ForwardRef as ReactComponent };